/**
 * Boni-Points cart UX (cart page + cart drawer).
 *
 *  - Manual discount-code field (in boni-cart-actions) → /discount/CODE — applies
 *    ANY code (minted BONI-, migrated LOV-, campaigns). Unchanged.
 *  - Adaptive redeem banner ABOVE the subtotal ([data-boni-redeem-banner]), for
 *    logged-in members, prioritised:
 *      1. a ready (unused) code  → "Dein 10%-Code ist bereit — anwenden" (applies it)
 *      2. else an affordable reward → "Spare 10% — jetzt einlösen" (mints + applies)
 *      3. else hidden.
 *
 * Strings via window.bfT (German fallbacks). State from /apps/loyalty.
 */
(function () {
  if (window.__boniCartInit) return;
  window.__boniCartInit = true;

  var PROXY = '/apps/loyalty';
  var statePromise = null;

  function t(key, fb) { return window.bfT ? window.bfT(key, fb) : fb; }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function init() {
    document.querySelectorAll('[data-boni-cart-actions]').forEach(wireActions);
    document.querySelectorAll('[data-boni-redeem-banner]').forEach(wireBanner);
  }

  // --- manual code field (unchanged) ---
  function wireActions(root) {
    if (root.__wired) return;
    root.__wired = true;
    var form = root.querySelector('[data-boni-code-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('[data-boni-code-input]');
        var code = ((input && input.value) || '').trim();
        if (code) applyCode(code);
      });
    }
  }

  // --- adaptive redeem banner ---
  function wireBanner(el) {
    if (el.__wired) return;
    el.__wired = true;
    if (el.getAttribute('data-customer') !== '1') { el.hidden = true; return; }
    loadState().then(function (s) { renderBanner(el, s); });
  }

  function renderBanner(el, s) {
    var action = el.querySelector('[data-boni-banner-action]');
    if (!action || !s || !s.logged_in) { el.hidden = true; return; }

    // 1. A ready (unused) code — prefer the highest-value percentage code.
    var unused = (s.codes || []).filter(function (c) { return c && !c.used && c.code; });
    var pct = unused.filter(function (c) { return c.type === 'percentage' && c.value; })
                    .sort(function (a, b) { return b.value - a.value; })[0];
    if (pct) {
      setBanner(el, action, t('boni_code_ready_pct', 'Dein {value} %-Code ist bereit — anwenden').replace('{value}', pct.value),
        function () { applyCode(pct.code); });
      return;
    }
    if (unused.length) {
      setBanner(el, action, t('boni_code_ready', 'Dein Gutschein ist bereit — anwenden'),
        function () { applyCode(unused[0].code); });
      return;
    }

    // 2. An affordable reward to mint.
    var reward = bestAffordable(s);
    if (reward) {
      setBanner(el, action, t('boni_cart_save', 'Spare {value} % — jetzt einlösen').replace('{value}', reward.value),
        function () { doRedeem(reward, action); });
      return;
    }

    // 3. Nothing actionable.
    el.hidden = true;
  }

  function setBanner(el, action, text, onClick) {
    el.hidden = false;
    action.textContent = text + '  →';
    action.onclick = function (e) { e.preventDefault(); onClick(); };
  }

  function applyCode(code) {
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  function loadState() {
    if (!statePromise) {
      statePromise = fetch(PROXY, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return statePromise;
  }

  function bestAffordable(s) {
    if (!s || !s.logged_in || !Array.isArray(s.catalog)) return null;
    var best = null;
    s.catalog.forEach(function (r) {
      if (s.balance >= r.cost_points && (!best || r.value > best.value)) best = r;
    });
    return best;
  }

  function doRedeem(reward, el) {
    if (el.__busy) return;
    var ok = window.confirm(
      t('boni_cart_confirm', '{points} Boni-Points gegen {value} % Rabatt einlösen? Die Punkte werden sofort abgezogen und nicht erstattet. Der Code verfällt nicht.')
        .replace('{points}', fmt(reward.cost_points)).replace('{value}', reward.value)
    );
    if (!ok) return;
    var original = el.textContent;
    el.__busy = true;
    el.classList.add('is-busy');
    el.textContent = t('boni_cart_redeeming', 'Wird eingelöst …');

    function fail() {
      window.alert(t('boni_cart_error', 'Einlösen fehlgeschlagen. Bitte erneut versuchen.'));
      el.__busy = false;
      el.classList.remove('is-busy');
      el.textContent = original;
    }

    fetch(PROXY + '/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ reward_id: reward.id })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || !res.d || !res.d.code) { fail(); return; }
        var url = res.d.apply_url || ('/discount/' + res.d.code);
        window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'redirect=/cart';
      })
      .catch(fail);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('boni:cart:applied', init);
})();
